import React from "react";

// Official Lexafide wordmark (dark type + blue "A"), served from /public.
export const Wordmark = ({ className = "", size = "md" }) => {
  const h = { sm: "h-4", md: "h-6", lg: "h-8" }[size] || "h-6";
  return (
    <img
      src="/lexafide-wordmark.png"
      alt="Lexafide"
      data-testid="lexafide-wordmark"
      className={`${h} w-auto select-none ${className}`}
      draggable="false"
    />
  );
};

// Mono, uppercase eyebrow with a leading electric-blue dot — signature site motif.
export const Eyebrow = ({ children, className = "", testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-2.5 font-mono text-[11px] uppercase tracking-[0.16em] text-ink-soft ${className}`}
  >
    <span className="inline-block w-1.5 h-1.5 rounded-full bg-accent" />
    {children}
  </span>
);

export default Wordmark;
